import CustomModal from "../../../common-utilities/core/modal";
import { useState, useEffect } from "react";
import { Button, TextField } from "@mui/material";
import {
  ACTIVATION_STATUS,
  BREAKFAST_LIST,
  CAT_LIST,
  CIRCLE_LIST,
  COFFEE_STATUS_LIST,
  CRAVERS_LAUNCH_PHASE_LIST,
  DISPLAY_BRAND,
  DMB_TYPE,
  FORMAT_LIST,
  LFL_LIST,
  REGIONS_LIST,
  SCREEN_FORMAT,
  SPLIT_LIST,
  STORE_OPERATION_LIST,
  STORE_STATUS_LIST,
  STORE_TYPE,
  STORE_TYPE_MAP,
  SUB_FORMAT_LIST,
  TIER_CITY_LIST,
  UserRoles,
} from "./config";

import {
  createUpdateStore,
  disableSaveButton,
  getSelectDcList,
  setRegionsData,
  userListSelectList,
} from "./utils";
import { clearRegionKeys } from "../../../common-utilities/utils/region-utils";
import AutocompleteComponent from "../../../common-utilities/core/styled-autocomplete";
import { formatDate } from "../../../../utils";
import { DATE_FORMATS } from "../../../../utils/constants";
import AutoCompleteMultiSelect from "../../../common-utilities/core/autocomplete-multiselect";
import {
  getOrderingPlatformList,
  getPriceCohortList,
} from "../../../cf-approval/components/document/api";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { REST_URLS } from "../../../common-utilities/utils/end-points/store-master";
import { INTRANETHOSTNAME } from "../../../common-utilities/utils/end-points";

export const CreateUpdateStoreModal = ({
  data,
  showForm,
  setShowForm,
  onSuccess,
  url,
  tokenKey,
  createStoreData,
  role,
}) => {
  const [storeData, setStoreData] = useState({});
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [amList, setAMList] = useState([]);
  const [opsList, setOpsList] = useState([]);
  const [rmList, setRmList] = useState([]);
  const [dcList, setDcList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [orderingPlatformList, setOrderingPlatformList] = useState([]);
  const [priceCohortList, setPriceCohortList] = useState([]);
  useEffect(() => {
    if (!showForm) {
      return;
    }
    if (data || createStoreData) {
      const finalData = { ...data, ...createStoreData };
      if (finalData.storeOpeningDate) {
        finalData.storeOpeningDate = formatDate(
          finalData.storeOpeningDate,
          DATE_FORMATS["YYYY-MM-DD"]
        );
      }
      if (finalData.storeTransferDate) {
        finalData.storeTransferDate = formatDate(
          finalData.storeTransferDate,
          DATE_FORMATS["YYYY-MM-DD"]
        );
      }
      if(!finalData.electricityChargePerUnit){
        finalData.electricityChargePerUnit = 12;
      }
      if(!finalData.conversionFactor){
        finalData.conversionFactor = 1;
      }
      setStoreData(finalData);
    }

    setRegionsData(
      data || createStoreData,
      countryList,
      setCountryList,
      setStateList,
      setCityList
    );
    (async () => {
      const dc = await getSelectDcList(null, null, tokenKey);
      setDcList(dc);
      const areaManger = await userListSelectList(
        {
          additionalRole: UserRoles.areaManger,
        },
        tokenKey
      );
      setAMList(areaManger);
      const regionalManger = await userListSelectList(
        {
          additionalRole: UserRoles.regionalManger,
        },
        tokenKey
      );
      setRmList(regionalManger);
      const opsManger = await userListSelectList(
        {
          additionalRole: UserRoles.opsManager,
        },
        tokenKey
      );
      setOpsList(opsManger);
      const allUsers = await userListSelectList({}, tokenKey);
      setUserList(allUsers);
    })();
  }, [data, showForm, tokenKey, createStoreData]);

  const clearData = () => {
    setStoreData({});
    setCountryList([]);
    setStateList([]);
    setCityList([]);
  };
  useEffect(() => {
    if (!showForm) {
      clearData();
    }
  }, [showForm]);
  useEffect(() => {
    getOrderingPlatformList(setOrderingPlatformList);
    getPriceCohortList(setPriceCohortList);
  }, []);

  const fetchGSTForState =  (stateName) => {
     invokeApi(
        HTTP_METHODS.GET,
        `${INTRANETHOSTNAME}${REST_URLS.GET_STATE_GST}`,
        null,
        { q: stateName },
        null,
        tokenKey
      ).then((response) => {
        if (!response.message) {
          let data = response?.results[0];
  setStoreData((prevDetails) => ({
          ...prevDetails,
          gstn: data?.gstN,
        }));
        }
      })
      .catch((err) => {})
  };

  // When the form is pre-filled (e.g. from the CF flow) with a state but no GST,
  // fetch GST for that state — the state is set directly via setStoreData, so it
  // never goes through onInputChange where fetchGSTForState is otherwise triggered.
  useEffect(() => {
    const prefilledState = (data || createStoreData)?.state;
    if (showForm && prefilledState && !(data || createStoreData)?.gstn) {
      fetchGSTForState(prefilledState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showForm, data, createStoreData]);

  const onInputChange = (e, type) => {
    switch (type) {
      case "select": {
        const { name, value } = e;
        setStoreData((prevDetails) => {
          clearRegionKeys(
            prevDetails,
            name,
            value,
            "country",
            "state",
            "city",
            setStateList,
            setCityList
          );
          return {
            ...prevDetails,
            [name]: value,
          };
        });
        
        // Fetch GST when state is selected
        if (name === "state" && value) {
          fetchGSTForState(value);
        }
        
        return;
      }
      case "multi": {
        setStoreData((prevDetails) => {
          const { name, value } = e;
          return {
            ...prevDetails,
            [name]: value,
          };
        });
        return;
      }
      default: {
        const { name, value } = e.target;
        setStoreData((prevDetails) => ({
          ...prevDetails,
          [name]: value,
        }));
      }
    }
  };
  return (
    <div className="store-create-edit-modal">
      {showForm && (
        <CustomModal
          classesToPreventClosing={["MuiAutocomplete-option"]}
          contentClassName={{
            customClass: "store-create-edit-modal-container",
          }}
          title={`${data ? "Update store details" : "Create new store"}`}
          onClose={() => setShowForm(null)}
        >
          {/* Group 1 - Basic Store Information */}
          <div className="field-group">
            <div className="field-row">
              <div className="input-field">
                <div className="mandatory-fields">
                  Name <span>*</span>
                </div>
                <TextField
                  size="small"
                  value={storeData.name || ""}
                  name="name"
                  type="text"
                  placeholder="Name"
                  className="new-textfield"
                  onChange={onInputChange}
                />
              </div>
              <div className="input-field">
                <div className="mandatory-fields">
                  Store Number <span>*</span>
                </div>
                <TextField
                  size="small"
                  value={storeData.storeNumber || ""}
                  name="storeNumber"
                  type="number"
                  placeholder="Store Number"
                  className="new-textfield"
                  onChange={onInputChange}
                />
              </div>
              <div className="input-field">
                <div className="mandatory-fields">
                  Satellite Number <span>*</span>
                </div>
                <TextField
                  size="small"
                  value={storeData.satelliteNumber || ""}
                  name="satelliteNumber"
                  type="number"
                  className="new-textfield"
                  placeholder="Satellite Number"
                  onChange={onInputChange}
                />
              </div>
            </div>

            <div className="field-row">
              <div className="input-field">
                <div className="mandatory-fields">
                  Sequence Number <span>*</span>
                </div>
                <TextField
                  size="small"
                  value={storeData.sequenceNumber || ""}
                  name="sequenceNumber"
                  className="new-textfield"
                  type="text"
                  placeholder="Sequence Number"
                  onChange={onInputChange}
                />
              </div>
              <div className="input-field">
                <div className="mandatory-fields">
                  Store Name<span>*</span>
                </div>
                <TextField
                  size="small"
                  value={storeData.ownerName || ""}
                  name="ownerName"
                  className="new-textfield"
                  type="text"
                  placeholder="Store Name"
                  onChange={onInputChange}
                />
              </div>
              <div className="input-field">
                <div className="mandatory-fields">
                  Store Type<span>*</span>
                </div>
                <AutocompleteComponent
                  classNamePrefix="custom_select"
                  className="sel-item"
                  options={STORE_TYPE}
                  placeholder="Store Type"
                  value={
                    ![undefined, null, ""].includes(storeData.storeType)
                      ? STORE_TYPE.find((i) => i.value === storeData.storeType)
                      : ""
                  }
                  disableClear={true}
                  onChange={(e, val) => {
                    onInputChange(
                      { name: "storeType", value: val?.value },
                      "select"
                    );
                  }}
                />
              </div>
            </div>

            <div className="field-row">
              <div className="input-field">
                Store Display Name
                <TextField
                  size="small"
                  value={storeData.restaurantName || ""}
                  name="restaurantName"
                  type="text"
                  className="new-textfield"
                  placeholder="Store Display Name"
                  onChange={onInputChange}
                />
              </div>
              <div className="input-field">
                <div className="mandatory-fields">
                  Format
                  <span>*</span>
                </div>
                <AutocompleteComponent
                  classNamePrefix="custom_select"
                  className="sel-item"
                  options={FORMAT_LIST}
                  placeholder="Format"
                  value={
                    ![undefined, null, ""].includes(storeData.format)
                      ? FORMAT_LIST.find((i) => i.value === storeData.format)
                      : ""
                  }
                  onChange={(e, val) => {
                    onInputChange(
                      { name: "format", value: val?.value },
                      "select"
                    );
                  }}
                  disableClear={true}
                />
              </div>
              <div className="input-field">
                <div className="mandatory-fields">
                  Sub Format
                  <span>*</span>
                </div>
                <AutocompleteComponent
                  classNamePrefix="custom_select"
                  className="sel-item"
                  options={SUB_FORMAT_LIST}
                  placeholder="Sub Format"
                  value={
                    ![undefined, null, ""].includes(storeData.subFormat)
                      ? SUB_FORMAT_LIST.find(
                          (i) => i.value === storeData.subFormat
                        )
                      : ""
                  }
                  onChange={(e, val) => {
                    onInputChange(
                      { name: "subFormat", value: val?.value },
                      "select"
                    );
                  }}
                  disableClear={true}
                />
              </div>
            </div>

            <div className="field-row">
              <div className="input-field">
                Store Hours
                <TextField
                  size="small"
                  value={storeData.storeHours || ""}
                  name="storeHours"
                  type="text"
                  className="new-textfield"
                  placeholder="Store Hours"
                  onChange={onInputChange}
                />
              </div>
              <div className="input-field">
                Cohort
                <AutocompleteComponent
                  classNamePrefix="custom_select"
                  className="sel-item"
                  options={CAT_LIST}
                  placeholder="Cohort"
                  value={
                    ![undefined, null, ""].includes(storeData.cat)
                      ? CAT_LIST.find((i) => i.value === storeData.cat)
                      : ""
                  }
                  onChange={(e, val) => {
                    onInputChange({ name: "cat", value: val?.value }, "select");
                  }}
                  disableClear={true}
                />
              </div>
              <div className="input-field">
                Price Cohort
                <AutocompleteComponent
                  classNamePrefix="custom_select"
                  className="sel-item"
                  options={priceCohortList}
                  placeholder="Price Cohort"
                  value={
                    ![undefined, null, ""].includes(storeData.priceCohort)
                      ? priceCohortList.find(
                          (i) => i.value === storeData.priceCohort
                        )
                      : ""
                  }
                  onChange={(e, val) => {
                    onInputChange(
                      { name: "priceCohort", value: val?.value },
                      "select"
                    );
                  }}
                  disableClear={true}
                />
              </div>
            </div>

            <div className="field-row">
              <div className="input-field">
                Breakfast
                <AutocompleteComponent
                  classNamePrefix="custom_select"
                  className="sel-item"
                  options={BREAKFAST_LIST}
                  placeholder="Breakfast"
                  value={
                    ![undefined, null, ""].includes(storeData.breakfast)
                      ? BREAKFAST_LIST.find(
                          (i) => i.value === storeData.breakfast
                        )
                      : ""
                  }
                  onChange={(e, val) => {
                    onInputChange(
                      { name: "breakfast", value: val?.value },
                      "select"
                    );
                  }}
                  disableClear={true}
                />
              </div>
            </div>
          </div>

          {/* Group 2 - Location Information */}
          <div className="field-group">
            <div className="field-row">
              <div className="input-field">
                <div className="mandatory-fields">
                  Address
                  <span>*</span>
                </div>
                <TextField
                  size="small"
                  value={storeData.address || ""}
                  name="address"
                  type="text"
                  placeholder="Address"
                  className="new-textfield"
                  onChange={onInputChange}
                />
              </div>
              <div className="input-field">
                <div className="mandatory-fields">
                  Country
                  <span>*</span>
                </div>
                <AutocompleteComponent
                  classNamePrefix="custom_select"
                  className="sel-item"
                  options={countryList}
                  placeholder="Country"
                  value={
                    ![undefined, null, ""].includes(storeData.country)
                      ? countryList.find((i) => i.value === storeData.country)
                      : ""
                  }
                  onChange={(e, val) => {
                    onInputChange(
                      { name: "country", value: val?.value },
                      "select"
                    );
                  }}
                  disableClear={true}
                />
              </div>
              <div className="input-field">
                <div className="mandatory-fields">
                  State
                  <span>*</span>
                </div>
                <AutocompleteComponent
                  classNamePrefix="custom_select"
                  className="sel-item"
                  options={stateList}
                  placeholder="State"
                  value={
                    ![undefined, null, ""].includes(storeData.state)
                      ? stateList.find((i) => i.value === storeData.state)
                      : ""
                  }
                  onChange={(e, val) => {
                    onInputChange(
                      { name: "state", value: val?.value },
                      "select"
                    );
                  }}
                  disableClear={true}
                />
              </div>
            </div>

            <div className="field-row">
              <div className="input-field">
                  <div className="mandatory-fields">
                City
                  <span>*</span>
                </div>
                <AutocompleteComponent
                  classNamePrefix="custom_select"
                  className="sel-item"
                  options={cityList}
                  placeholder="City"
                  value={
                    ![undefined, null, ""].includes(storeData.city)
                      ? cityList.find((i) => i.value === storeData.city)
                      : ""
                  }
                  onChange={(e, val) => {
                    onInputChange(
                      { name: "city", value: val?.value },
                      "select"
                    );
                  }}
                  disableClear={true}
                />
              </div>
              <div className="input-field">
                <div className="mandatory-fields">
                  Region
                  <span>*</span>
                </div>
                <AutocompleteComponent
                  classNamePrefix="custom_select"
                  className="sel-item"
                  options={REGIONS_LIST}
                  placeholder="Region"
                  value={
                    ![undefined, null, ""].includes(storeData.region)
                      ? REGIONS_LIST.find((i) => i.value === storeData.region)
                      : ""
                  }
                  onChange={(e, val) => {
                    onInputChange(
                      { name: "region", value: val?.value },
                      "select"
                    );
                  }}
                  disableClear={true}
                />
              </div>
              <div className="input-field">
                Area
                <TextField
                  size="small"
                  value={storeData.area || ""}
                  name="area"
                  type="text"
                  className="new-textfield"
                  placeholder="Area"
                  onChange={onInputChange}
                />
              </div>
            </div>

            <div className="field-row">
              <div className="input-field">
                Pincode
                <TextField
                  size="small"
                  value={storeData.pinCode || ""}
                  name="pinCode"
                  type="number"
                  placeholder="Pincode"
                  className="new-textfield"
                  onChange={onInputChange}
                />
              </div>
              <div className="input-field">
                Latitude
                <TextField
                  size="small"
                  value={storeData.latitude || ""}
                  name="latitude"
                  type="number"
                  placeholder="Latitude"
                  className="new-textfield"
                  onChange={onInputChange}
                />
              </div>
              <div className="input-field">
                Longtitude
                <TextField
                  size="small"
                  value={storeData.longitude || ""}
                  name="longitude"
                  type="number"
                  placeholder="Longtitude"
                  className="new-textfield"
                  onChange={onInputChange}
                />
              </div>
            </div>

            <div className="field-row">
              <div className="input-field">
                Store Link
                <TextField
                  size="small"
                  value={storeData.storeLink || ""}
                  name="storeLink"
                  type="text"
                  className="new-textfield"
                  placeholder="Store Link"
                  onChange={onInputChange}
                />
              </div>
              <div className="input-field">
                
                  Tier-City
            
              
                <AutocompleteComponent
                  classNamePrefix="custom_select"
                  className="sel-item"
                  options={TIER_CITY_LIST}
                  placeholder="Tier-City"
                  value={
                    ![undefined, null, ""].includes(storeData.tierCity)
                      ? TIER_CITY_LIST.find(
                          (i) => i.value === storeData.tierCity
                        )
                      : ""
                  }
                  onChange={(e, val) => {
                    onInputChange(
                      { name: "tierCity", value: val?.value },
                      "select"
                    );
                  }}
                  disableClear={true}
                />
              </div>
              <div className="input-field">
                GST
                <TextField
                  size="small"
                  value={storeData.gstn || ""}
                  name="gstn"
                  type="text"
                  className="new-textfield"
                  placeholder="GST"
                  onChange={onInputChange}
                />
              </div>
            </div>
          </div>


       
          {/* Group 3 - Store Opening & Status */}
          <div className="field-group">
            <div className="field-row">
              <div className="input-field">
                <div className="mandatory-fields">
                  Store Opening Date
                  {storeData?.status === "Active" && <span>*</span>}
                </div>
                <TextField
                  size="small"
                  value={storeData.storeOpeningDate || ""}
                  name="storeOpeningDate"
                  type="date"
                  placeholder="Store Opening Date"
                  className="new-textfield"
                  onChange={onInputChange}
                />
              </div>
              <div className="input-field">
                Store Transfer Date
                <TextField
                  size="small"
                  value={storeData.storeTransferDate || ""}
                  name="storeTransferDate"
                  type="date"
                  placeholder="Store Transfer Date"
                  className="new-textfield"
                  onChange={onInputChange}
                />
              </div>
              <div className="input-field">
                <div className="mandatory-fields">
                  Status
                  <span>*</span>
                </div>
                <AutocompleteComponent
                  classNamePrefix="custom_select"
                  className="sel-item"
                  options={STORE_STATUS_LIST}
                  placeholder="Store Status"
                  value={
                    ![undefined, null, ""].includes(storeData.status)
                      ? STORE_STATUS_LIST.find(
                          (i) => i.value === storeData.status
                        )
                      : ""
                  }
                  onChange={(e, val) => {
                    onInputChange(
                      { name: "status", value: val?.value },
                      "select"
                    );
                  }}
                  disableClear={true}
                />
              </div>
            </div>

            <div className="field-row">
              <div className="input-field">
                <div className="mandatory-fields">
                  Store Closure Date
                  {storeData?.status === "Inactive" && <span>*</span>}
                </div>
                <TextField
                  size="small"
                  value={
                    storeData.storeClosureDate
                      ? new Date(storeData.storeClosureDate)
                          .toISOString()
                          .substring(0, 10)
                      : ""
                  }
                  name="storeClosureDate"
                  type="date"
                  className="new-textfield"
                  placeholder="Store Closure Date"
                  onChange={onInputChange}
                />
              </div>
              <div className="input-field">
                Remodel date
                <TextField
                  size="small"
                  value={
                    storeData.remodelDate
                      ? new Date(storeData.remodelDate)
                          .toISOString()
                          .substring(0, 10)
                      : ""
                  }
                  name="remodelDate"
                  type="date"
                  className="new-textfield"
                  placeholder="Remodel date"
                  onChange={onInputChange}
                />
              </div>
              <div className="input-field">
                POS Migration Date (Posist to Rista)
                <TextField
                  size="small"
                  value={
                    storeData.posMigrationDate
                      ? new Date(storeData.posMigrationDate)
                          .toISOString()
                          .substring(0, 10)
                      : ""
                  }
                  name="posMigrationDate"
                  type="date"
                  className="new-textfield"
                  placeholder="POS Migration Date"
                  onChange={onInputChange}
                />
              </div>
            </div>
          </div>

          {/* Group 4 - Management & Contact */}
          <div className="field-group">
            <div className="field-row">
              <div className="input-field">
                <div className="mandatory-fields">
                  Area Manager{" "}
                  {storeData?.storeType !== STORE_TYPE_MAP.FOFO && (
                    <span>*</span>
                  )}
                </div>
                <AutocompleteComponent
                  classNamePrefix="custom_select"
                  placeholder="Area Manager"
                  disableClear={true}
                  className="sel-item"
                  options={amList}
                  value={
                    ![undefined, null, ""].includes(storeData.am)
                      ? amList.find((i) => i.value === storeData.am)
                      : ""
                  }
                  onChange={(e, val) => {
                    onInputChange({ name: "am", value: val?.value }, "select");
                  }}
                />
              </div>
              <div className="input-field">
                <div className="mandatory-fields">
                  Regional Manager{" "}
                  {storeData?.storeType !== STORE_TYPE_MAP.FOFO && (
                    <span>*</span>
                  )}
                </div>
                <AutocompleteComponent
                  classNamePrefix="custom_select"
                  placeholder="Regional Manager"
                  className="sel-item"
                  options={rmList}
                  value={
                    ![undefined, null, ""].includes(storeData.rm)
                      ? rmList.find((i) => i.value === storeData.rm)
                      : ""
                  }
                  onChange={(e, val) => {
                    onInputChange({ name: "rm", value: val?.value }, "select");
                  }}
                  disableClear={true}
                />
              </div>
              <div className="input-field">
                <div className="mandatory-fields">Ops Manager </div>
                <AutocompleteComponent
                  classNamePrefix="custom_select"
                  placeholder="Ops Manager"
                  className="sel-item"
                  options={opsList}
                  value={
                    ![undefined, null, ""].includes(storeData.opsManager)
                      ? opsList.find((i) => i.value === storeData.opsManager)
                      : ""
                  }
                  onChange={(e, val) => {
                    onInputChange(
                      { name: "opsManager", value: val?.value },
                      "select"
                    );
                  }}
                />
              </div>
            </div>

            <div className="field-row">
              <div className="input-field">
                <div className="mandatory-fields">
                  Store Email<span>*</span>
                </div>
                <TextField
                  size="small"
                  value={storeData.email || ""}
                  name="email"
                  type="text"
                  placeholder="Store Email"
                  className="new-textfield"
                  onChange={onInputChange}
                />
              </div>
              <div className="input-field">
                FZ Name
                <TextField
                  size="small"
                  value={storeData.fzName || ""}
                  name="fzName"
                  type="text"
                  className="new-textfield"
                  placeholder="FZ Name"
                  onChange={onInputChange}
                />
              </div>
              <div className="input-field">
                Contact Number
                <TextField
                  size="small"
                  value={storeData.contactNumber || ""}
                  name="contactNumber"
                  className="new-textfield"
                  type="text"
                  placeholder="Contact Number"
                  onChange={onInputChange}
                />
              </div>
            </div>
          </div>

          {/* Hide from UI - LFL */}
          {/* <div className="input-field">
            LFL
            <AutocompleteComponent
              classNamePrefix="custom_select"
              label="LFL"
              className="sel-item"
              options={LFL_LIST}
              value={
                ![undefined, null, ""].includes(storeData.tier)
                  ? LFL_LIST.find((i) => i.value === storeData.tier)
                  : ""
              }
              onChange={(e, val) => {
                onInputChange({ name: "tier", value: val?.value }, "select");
              }}
              disableClear={true}
            />
          </div> */}

          {/* Hide from UI - Posist Key */}
          {/* <div className="input-field">
            <div className="mandatory-fields">
              Posist Key
              {storeData?.status === "Active" && <span>*</span>}
            </div>
            <TextField
              size="small"
              value={storeData.posistKey || ""}
              name="posistKey"
              type="text"
              className="new-textfield"
              placeholder="Posist Key"
              onChange={onInputChange}
            />
          </div> */}

          {/* Hide from UI - FS Team Member */}
          {/* <div className="input-field">
            FS Team Member
            <AutocompleteComponent
              classNamePrefix="custom_select"
              label="FS Team Member"
              className="sel-item"
              options={userList}
              value={
                ![undefined, null, ""].includes(storeData.firstLevelEscalation)
                  ? userList.find(
                      (i) => i.value === storeData.firstLevelEscalation
                    )
                  : ""
              }
              onChange={(e, val) => {
                onInputChange(
                  { name: "firstLevelEscalation", value: val?.value },
                  "select"
                );
              }}
              disableClear={true}
            />
          </div> */}

          {/* Hide from UI - Store operations classification */}
          {/* <div className="input-field">
            Store operations classification
            <AutocompleteComponent
              classNamePrefix="custom_select"
              label="Store operations classification"
              className="sel-item"
              options={STORE_OPERATION_LIST}
              value={
                ![undefined, null, ""].includes(
                  storeData.storeOperationsClassification
                )
                  ? STORE_OPERATION_LIST.find(
                      (i) => i.value === storeData.storeOperationsClassification
                    )
                  : ""
              }
              onChange={(e, val) => {
                onInputChange(
                  { name: "storeOperationsClassification", value: val?.value },
                  "select"
                );
              }}
              disableClear={true}
            />
          </div> */}

          {/* Hide from UI - QR Ordering deactivation */}
          {/* <div className="input-field">
            QR Ordering deactivation
            <TextField
              size="small"
              value={
                storeData.qrOrderingDeactivation
                  ? new Date(storeData.qrOrderingDeactivation)
                      .toISOString()
                      .substring(0, 10)
                  : ""
              }
              name="qrOrderingDeactivation"
              type="date"
              className="new-textfield"
              placeholder="QR Ordering deactivation"
              onChange={onInputChange}
            />
          </div> */}

          {/* Hide from UI - Outlier */}
          {/* <div className="input-field">
            Outlier
            <TextField
              size="small"
              value={storeData.typeOfDecor || ""}
              name="typeOfDecor"
              type="text"
              className="new-textfield"
              placeholder="Outlier"
              onChange={onInputChange}
            />
          </div> */}

          {/* Group 5 - Technical & System */}
          <div className="field-group">
            <div className="field-row">
              <div className="input-field">
                <div className="mandatory-fields">
                  DC<span>*</span>
                </div>
                <AutocompleteComponent
                  classNamePrefix="custom_select"
                  className="sel-item"
                  options={dcList}
                  placeholder="DC"
                  value={
                    ![undefined, null, ""].includes(storeData.dc)
                      ? dcList.find((i) => i.value === storeData.dc)
                      : ""
                  }
                  onChange={(e, val) => {
                    onInputChange({ name: "dc", value: val?.value }, "select");
                  }}
                  disableClear={true}
                />
              </div>
              <div className="input-field">
                <div className="mandatory-fields">
                  Electricity Unit Rate
                  <span>*</span>
                </div>
                <TextField
                  size="small"
                  value={storeData.electricityChargePerUnit || ""}
                  name="electricityChargePerUnit"
                  type="number"
                  className="new-textfield"
                  placeholder="Electricity Charge Per Unit"
                  onChange={onInputChange}
                />
              </div>
              <div className="input-field">
                <div className="mandatory-fields">
                  Conversion Factor
                  <span>*</span>
                </div>
                <TextField
                  size="small"
                  value={storeData.conversionFactor || ""}
                  name="conversionFactor"
                  type="number"
                  className="new-textfield"
                  placeholder="Conversion Factor"
                  onChange={onInputChange}
                />
              </div>
            </div>

            <div className="field-row">
              <div className="input-field">
                DMB Type
                <AutocompleteComponent
                  classNamePrefix="custom_select"
                  className="sel-item"
                  options={DMB_TYPE}
                  placeholder="DMB Type"
                  value={
                    ![undefined, null, ""].includes(storeData.dmbType)
                      ? DMB_TYPE.find((i) => i.value === storeData.dmbType)
                      : ""
                  }
                  onChange={(e, val) => {
                    onInputChange(
                      { name: "dmbType", value: val?.value },
                      "select"
                    );
                  }}
                  disableClear={true}
                />
              </div>
              <div className="input-field">
                Screens Format
                <AutocompleteComponent
                  classNamePrefix="custom_select"
                  className="sel-item"
                  options={SCREEN_FORMAT}
                  placeholder="Screens Format"
                  value={
                    ![undefined, null, ""].includes(storeData.screensFormat)
                      ? SCREEN_FORMAT.find(
                          (i) => i.value === storeData.screensFormat
                        )
                      : ""
                  }
                  onChange={(e, val) => {
                    onInputChange(
                      { name: "screensFormat", value: val?.value },
                      "select"
                    );
                  }}
                  disableClear={true}
                />
              </div>
              <div className="input-field">
                Count Of Screens
                <TextField
                  size="small"
                  value={storeData.countOfScreens || ""}
                  name="countOfScreens"
                  type="number"
                  className="new-textfield"
                  placeholder="Count Of Screens"
                  onChange={onInputChange}
                />
              </div>
            </div>

            {role === "admin" && (
              <div className="field-row">
                <div className="input-field">
                  Magic Pin ID
                  <TextField
                    size="small"
                    value={storeData.magicPinId || ""}
                    name="magicPinId"
                    type="text"
                    className="new-textfield"
                    placeholder="Magic Pin ID"
                    onChange={onInputChange}
                  />
                </div>
                <div className="input-field">
                  Swiggy ID
                  <TextField
                    size="small"
                    value={storeData.swiggyId || ""}
                    name="swiggyId"
                    type="text"
                    className="new-textfield"
                    placeholder="Swiggy ID"
                    onChange={onInputChange}
                  />
                </div>
                <div className="input-field">
                  Zomato ID
                  <TextField
                    size="small"
                    value={storeData.zomatoId || ""}
                    name="zomatoId"
                    type="text"
                    className="new-textfield"
                    placeholder="Zomato ID"
                    onChange={onInputChange}
                  />
                </div>
              </div>
            )}

            <div className="field-row">
              <div className="input-field">
                Covers
                <TextField
                  size="small"
                  value={storeData.covers || ""}
                  name="covers"
                  type="text"
                  className="new-textfield"
                  placeholder="Covers"
                  onChange={onInputChange}
                />
              </div>
              <div className="input-field">
                Trainer
                <TextField
                  size="small"
                  value={storeData.trainer || ""}
                  name="trainer"
                  type="text"
                  className="new-textfield"
                  placeholder="Trainer"
                  onChange={onInputChange}
                />
              </div>
              <div className="input-field">
                Trainer Email
                <TextField
                  size="small"
                  value={storeData.trainerEmail || ""}
                  name="trainerEmail"
                  type="text"
                  className="new-textfield"
                  placeholder="Trainer Email"
                  onChange={onInputChange}
                />
              </div>
                <div className="input-field">
            Circle
            <AutocompleteComponent
              classNamePrefix="custom_select"
              label="Circle"
              className="sel-item"
              options={CIRCLE_LIST}
              value={
                ![undefined, null, ""].includes(storeData.circle)
                  ? CIRCLE_LIST.find((i) => i.value === storeData.circle)
                  : ""
              }
              onChange={(e, val) => {
                onInputChange({ name: "circle", value: val?.value }, "select");
              }}
              disableClear={true}
            />
          </div>

            </div>
          </div>

          {/* Hide from UI - Make It a Meal */}
          {/* <div className="input-field">
            <div className="mandatory-fields">Make It a Meal</div>
            <AutocompleteComponent
              classNamePrefix="custom_select"
              label="Make It a Meal"
              className="sel-item"
              options={COFFEE_STATUS_LIST}
              value={
                ![undefined, null, ""].includes(storeData.makeItMeal)
                  ? COFFEE_STATUS_LIST.find(
                      (i) => i.value === storeData.makeItMeal
                    )
                  : ""
              }
              onChange={(e, val) => {
                onInputChange(
                  { name: "makeItMeal", value: val?.value },
                  "select"
                );
              }}
              disableClear={true}
            />
          </div> */}

          {/* Hide from UI - Split */}
          {/* <div className="input-field">
            Split
            <AutocompleteComponent
              classNamePrefix="custom_select"
              label="Split"
              className="sel-item"
              options={SPLIT_LIST}
              value={
                ![undefined, null, ""].includes(storeData.split)
                  ? SPLIT_LIST.find((i) => i.value === storeData.split)
                  : ""
              }
              onChange={(e, val) => {
                onInputChange({ name: "split", value: val?.value }, "select");
              }}
              disableClear={true}
            />
          </div> */}

          {/* Hide from UI - Maintenance User */}
          {/* <div className="input-field">
            Maintenance User
            <AutocompleteComponent
              classNamePrefix="custom_select"
              placeholder=" Maintenance User"
              className="sel-item"
              options={userList}
              label=" Maintenance User"
              value={
                ![undefined, null, ""].includes(storeData.maintenanceUser)
                  ? userList.find(
                      (i) =>
                        parseInt(i.value) === storeData.maintenanceUser ||
                        i.value === storeData.maintenanceUser
                    )
                  : ""
              }
              onChange={(e, val) => {
                onInputChange(
                  { name: "maintenanceUser", value: val?.value },
                  "select"
                );
              }}
            />
          </div> */}

          {/* Hide from UI - Maintenance User Number */}
          {/* <div className="input-field">
            Maintenance User Number
            <TextField
              size="small"
              value={storeData.maintenanceUserNumber || ""}
              name="maintenanceUserNumber"
              className="new-textfield"
              type="number"
              placeholder="Maintenance User Number"
              onChange={onInputChange}
            />
          </div> */}

          {/* Hide from UI - PAN */}
          {/* <div className="input-field">
            PAN
            <TextField
              size="small"
              value={storeData.pan || ""}
              name="pan"
              type="text"
              className="new-textfield"
              placeholder="PAN"
              onChange={onInputChange}
            />
          </div> */}

          {/* Hide from UI - FSSAI No. */}
          {/* <div className="input-field">
            FSSAI No.
            <TextField
              size="small"
              value={storeData.fssaiNo || ""}
              name="fssaiNo"
              type="text"
              className="new-textfield"
              placeholder="FSSAI No."
              onChange={onInputChange}
            />
          </div> */}

          {/* Hide from UI - Operating Entity Name */}
          {/* <div className="input-field">
            Operating Entity Name
            <TextField
              size="small"
              value={storeData.franchiseBusinessName || ""}
              name="franchiseBusinessName"
              type="text"
              className="new-textfield"
              placeholder="Operating Entity Name"
              onChange={onInputChange}
            />
          </div> */}

          <div className="save-button">
            <Button
              disabled={disableSaveButton(storeData)}
              size="small"
              variant="outlined"
              onClick={() =>
                createUpdateStore(
                  storeData,
                  setShowForm,
                  onSuccess,
                  url,
                  tokenKey
                )
              }
            >
              {storeData?.id ? "Update Store Details" : "Create new store"}
            </Button>
          </div>
        </CustomModal>
      )}
    </div>
  );
};

export default CreateUpdateStoreModal;
